import { getSuccessCriteriaDisplayName } from '../../getSuccessCriteriaDisplayName';
import type { Metric } from '../../types';

interface MetricSuccessCriteriaProps {
  metric: Metric;
}

export const MetricSuccessCriteria: React.FC<MetricSuccessCriteriaProps> = ({ metric }) => {
  if (metric.successCriteria) {
    return <span>{getSuccessCriteriaDisplayName(metric.successCriteria)}</span>;
  }

  if (metric.kind === 'click' || metric.kind === 'pageview') {
    return <span>{getSuccessCriteriaDisplayName('HigherThanBaseline')}</span>;
  }

  return null;
};
